import React, { useEffect, useState } from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Tooltip,
  Legend,
} from "chart.js";
import { Line } from "react-chartjs-2";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Tooltip,
  Legend
);

function ClientTrend({ onClose, chartData }) {
  const [labels, setLabels] = useState([]);
  const [dataset, setDataset] = useState([]);
  useEffect(() => {
    if (!chartData) return;

    // Build labels: Q1, Q2, Q3, Q4 for each year
    let tempLabels = [];
    let tempValues = [];

    chartData.forEach((row) => {
      tempLabels.push(row.financial_year);
      tempValues.push(row.total_clients);
    });

    setLabels(tempLabels);
    setDataset(tempValues);
  }, [chartData]);

  const data = {
    labels: labels,
    datasets: [
      {
        label: "Clients",
        data: dataset,
        borderWidth: 3,
        tension: 0.4, // smooth curve
        fill: false,
        pointRadius: 4,
        pointHoverRadius: 6,
        borderColor: "#1b80f4",
        backgroundColor: "#1b80f4",
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: { display: false },
      datalabels: { display: false },
      tooltip: {
        callbacks: {
          label: (context) => `${context.raw}`,
        },
      },
    },
    scales: {
      y: {
        title: {
          display: true,
          text: "Clients", // 👈 Y-axis title
          font: { size: 14, weight: "bold" },
        },
        ticks: {
          callback: (value) => `${value}`,
        },
      },
    },
  };

  return (
    <div className="modal fade show d-block" tabIndex="-1">
      <div className="modal-dialog modal-xl">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Clients Developed Over Last 5 Years</h5>
            <button
              type="button"
              className="btn-close"
              onClick={onClose}
            ></button>
          </div>

          <div className="modal-body">
            <div className="row">
              <div style={{ width: "100%", height: "420px" }}>
                {data?.datasets?.length > 0 && (
                  <Line data={data} options={options} />
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ClientTrend;
